import { useParams, Link } from "react-router-dom"
import { useGetLessonsQuery } from "./lessonsApiSlice"
import Lesson from "./Lesson"
import useTitle from "../../hooks/useTitle"
import PulseLoader from "react-spinners/PulseLoader"

const LessonsList = ({ txt, all, lessonsIds, changeId, groupsIds }) => {
  const { groupId, type } = useParams()
  useTitle("geshtop-Exercise: Lessons List")

  const {
    data: lessons,
    isLoading,
    isFetching,
    isError,
    isSuccess,
    error,
  } = useGetLessonsQuery({all}, {
    refetchOnMountOrArgChange: true,
  })
  if (isLoading || isFetching) return <PulseLoader color="#FFF" />
  if (isError) return <>
   <section className="list__action-buttons">
        <Link to={`/${type}/${groupId}/lessons/new`}>
          New Lesson
        </Link>
      </section>
  <p className="errmsg">{error?.data?.message}</p>
  </>

  
  // סינון השיעורים לפי טקסט וקבוצה
  let filteredLessonIds = []

  if (lessons?.ids?.length) {
    filteredLessonIds = lessons.ids.filter(id => {
      const lesson = lessons.entities[id]
      const matchesTxt = !txt || lesson.title.toLowerCase().includes(txt.toLowerCase())
      const matchesGroup = groupId === "0" || lesson.group._id === groupId
      const groupsMatch = groupsIds.length === 0 || groupsIds.includes(lesson.group._id)
      return matchesTxt && matchesGroup && groupsMatch
    })
  }

  const tableContent = filteredLessonIds.map(lessonId => (
    <Lesson
      key={lessonId}
      lesson={lessons.entities[lessonId]}
      lessonsIds={lessonsIds}
      changeId={changeId}
      lessonId={lessonId}
      all={all}
    />
  ))

  return (
    <>
      <section className="list__action-buttons">
        <Link to={`/${type}/${groupId}/lessons/new`}>
          New Lesson
        </Link>
      </section>

      <table className="table table--lessons">
        <thead className="table__thead">
          <tr>
            <th className="table__th lesson__lessonname">קבוצה</th>
            <th className="table__th lesson__lessonname">שם השיעור</th>
            <th className="table__th lesson__lessonname">מס השיעורים</th>
            <th className="table__th lesson__name">תאריך</th>
            <th className="table__th lesson__name">דווח</th>
            <th className="table__th lesson__edit">#</th>
          </tr>
        </thead>
        <tbody>
          {tableContent}
        </tbody>
      </table>
    </>
  )
}

export default LessonsList

